/** Regel für das automatische Stempeln am Ladengerät (autoClock.ts) – ohne Abhängigkeiten, damit sie testbar ist. */
import type { User } from '../../lib/types';

/** Mitarbeiter mit Recht time.clock an einem als Ladenkasse markierten Gerät – nicht Administratoren (Inhaber), nicht vor der Passwortänderung. */
export function autoClockApplies(user: Pick<User, 'role' | 'permissions' | 'mustChangePassword'> | null | undefined, device: boolean): boolean {
  return !!user && device && user.role !== 'admin' && user.permissions.includes('time.clock') && !user.mustChangePassword;
}
